<script>
import { Line, mixins } from 'vue-chartjs'
import 'chartjs-plugin-zoom'
import 'chartjs-plugin-streaming'
const { reactiveProp } = mixins

const cpuDatasetIndex = 0
const ramDatasetIndex = 1
export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data () {
    return {
      hsmSecsDiff: 0,
      scaleSettingTime: Date.now()
    }
  },
  mounted () {
    this.$store.dispatch('cpuMon/getHsmDateDiff').then(diff => {
      this.hsmSecsDiff = diff
    })
    this.addPreviousData()

    const chartOptions = this.options
    chartOptions.scales.xAxes[0].realtime.onRefresh = this.onRefresh
    this.renderChart(this.chartData, chartOptions)
  },
  computed: {
    isStarted () {
      return this.$store.getters['cpuMon/isStarted']
    },
    timeScale () {
      return this.$store.state.cpuMon.timeScale
    },
    cpuDataset () {
      return this.$store.state.cpuMon.cpuDataset
    },
    ramDataset () {
      return this.$store.state.cpuMon.ramDataset
    },
    darkMode () {
      return this.$store.state.ui.darkModeEnabled
    },
    locale () {
      return this.$store.state.locale.locale
    }
  },
  methods: {
    onRefresh (chart) {
      // console.log('myRefresh')
      // UPDATE PAUSE (!chart at the isStarted watch is called)
      chart.scales['x-axis-0'].options.realtime.pause = !this.isStarted

      // UPDATE COLORS
      chart.scales['y-axis-0'].options.gridLines.color = this.$store.state.ui
        .darkModeEnabled
        ? 'rgba(100, 100, 100, 1)'
        : 'rgba(0, 0, 0, 0.1)'

      // UPDATE LANGUAGE
      chart.data.datasets[cpuDatasetIndex].label = this.$t('processing')
      chart.data.datasets[ramDatasetIndex].label = this.$t('memory')

      // UPDATE DURATION
      chart.scales[
        'x-axis-0'
      ].options.realtime.duration = this.timeScale.timeScale

      // UPDATE DELAY
      const helperDelay = 4
      const totalDelay = helperDelay + this.hsmSecsDiff * -1000
      chart.scales['x-axis-0'].options.realtime.delay = totalDelay

      this.chart = chart
    },
    addPreviousData () {
      this.chartData.datasets[
        cpuDatasetIndex
      ].data = this.$store.state.cpuMon.cpuDataset.slice()
      this.chartData.datasets[
        ramDatasetIndex
      ].data = this.$store.state.cpuMon.ramDataset.slice()
    }
  },
  watch: {
    locale (val) {
      this.addPreviousData()
    },
    darkMode (val) {
      this.addPreviousData()
      this.renderChart(this.chartData, this.options)
    },
    cpuDataset (val) {
      // UPDATE DATA
      if (this.cpuDataset.length === 0) {
        // Dataset was reseted
        this.chartData.datasets[cpuDatasetIndex].data = []
        this.chartData.datasets[ramDatasetIndex].data = []
      } else if (this.isStarted) {
        const datasetLastIndex = this.cpuDataset.length - 1
        // console.log(this.cpuDataset[datasetLastIndex])
        // console.log(this.ramDataset[datasetLastIndex])
        this.chartData.datasets[cpuDatasetIndex].data.push(
          this.cpuDataset[datasetLastIndex]
        )
        this.chartData.datasets[ramDatasetIndex].data.push(
          this.ramDataset[datasetLastIndex]
        )
        this.$data._chart.update()
      }
    },
    isStarted (val) {
      this.scaleSettingTime = Date.now()
    },
    timeScale (val) {
      this.scaleSettingTime = Date.now()
    }
  }
}
</script>
